module.exports = __webpack_public_path__ + "static/media/cross.ca35185a.svg";